import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {LeftpanelComponent} from '../../../leftpanel/leftpanel.component';

@Component({
  selector: 'language-commands',
  templateUrl: './language-commands.component.html',
  styleUrls: ['./language-commands.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LanguageCommandsComponent implements OnInit {

  @Input() languageSnippets;

  constructor(private platform: LeftpanelComponent) { }

  ngOnInit(): void {
  }

  copyMessage(code) {
    const selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';

    // decode the URL-encoded text
    const decodedText = decodeURIComponent(code);

    selBox.value = decodedText;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.platform.openSnackBar('Copied to clipboard.', 'Success', {
      duration: 2000,
      verticalPosition: 'top',
      horizontalPosition: 'center'
    });
  }

  showCode(code: string | 'ERR_ASSERTION' | number | HTMLElement) {
    console.log('@@', code);
  }
}
